module.exports = __webpack_public_path__ + "img/college_of_liberal_arts_and_sciences.049ac0b7.png";